var map = {
	"./Euro2020Final-1370.jpg": 114,
	"./Euro2020Final-1407.jpg": 115,
	"./Euro2020Final-1425.jpg": 116,
	"./Euro2020Final-1428.jpg": 117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 113;